import { render, staticRenderFns } from "./ConfirmDiscard.vue?vue&type=template&id=00c53424&"
import script from "./ConfirmDiscard.vue?vue&type=script&lang=js&"
export * from "./ConfirmDiscard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports